
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";
import GroupMessagesVue from "@/components/GroupMessages.vue";
import StudentErrorsVue from "@/components/StudentErrors.vue";

export default defineComponent({
  components: {
    GroupMessagesVue,
    StudentErrorsVue,
  },
  name: "StudentBoard",
  computed: {
    ...mapState(["currentUser", "currentGroup", "loadedOneUserById"]),
  },
  methods: {
    ...mapActions(["getGroupById", "getOneUserById"]),
  },
  mounted() {
    this.getGroupById(this.currentUser.groups[0]);
    this.getOneUserById(this.$route.params.id);
  },
});
